
const CUSTOMER_NAV = (companyId) => [
  { to: '/dashboard', icon: 'bi-grid-1x2-fill', label: 'Dashboard' },
  {
    key: 'company',
    icon: 'bi-building',
    label: 'Company',
    children: [
      { to: `/companies/view/${companyId}`, icon: 'bi-eye', label: 'View' },
      { to: `/companies/edit/${companyId}`, icon: 'bi-pencil', label: 'Edit' },
    ],
  },
  { to: '/analytics', icon: 'bi-shield-check', label: 'Verification Log' },
  { to: '/api-usage', icon: 'bi-lightning-charge', label: 'API Usage' },
  { to: '/notifications', icon: 'bi-bell', label: 'Notifications' },
];

const ADMIN_NAV = [
  { to: '/dashboard', icon: 'bi-grid-1x2-fill', label: 'Dashboard' },
  { to: '/logs', icon: 'bi-clock-history', label: 'Logs' },
  { to: '/analytics', icon: 'bi-shield-check', label: 'Verification Log' },
  { to: '/notifications', icon: 'bi-bell', label: 'Notifications' },
];

const SUPERADMIN_NAV = [
  ...ADMIN_NAV,
   {
    key: 'company',
    icon: 'bi-building',
    label: 'Company',
    children: [
      { to: '/companies', icon: 'bi-list', label: 'List' },
      { to: '/addcompany', icon: 'bi-plus', label: 'Add' },
    ],
  },
  { to: '/main-companies', icon: 'bi-diagram-2', label: 'Main Companies' },
  {
    key: 'providers',
    icon: 'bi-diagram-3',
    label: 'Providers',
    children: [
      { to: '/providers', icon: 'bi-list', label: 'List' },
      { to: '/addprovider', icon: 'bi-plus', label: 'Add' },
    ],
  },
  {
    key: 'services',
    icon: 'bi-headset',
    label: 'Services',
    children: [
      { to: '/services', icon: 'bi-list', label: 'List' },
      { to: '/addservice', icon: 'bi-plus', label: 'Add' },
    ],
  },
  { to: '/audit-logs', icon: 'bi-journal-text', label: 'Audit Logs' },
  { to: '/dailystats', icon: 'bi-graph-up', label: 'Daily Stats' },
  { to: '/api-usage', icon: 'bi-lightning-charge', label: 'API Usage' },
  { to: '/roles', icon: 'bi-shield-lock', label: 'Roles' },
  { to: '/opportunities', icon: 'bi-lightbulb', label: 'Feature Opportunities' },
];

export function getNavForRole(role, companyId) {
  switch (role) {
    case 'SuperAdmin':
      return SUPERADMIN_NAV;
    case 'Admin':
      return ADMIN_NAV;
    default:
      return CUSTOMER_NAV(companyId);
  }
}
